import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
  'uppercase rounded-none transition-all font-heading tracking-heading inline-flex items-center justify-center whitespace-nowrap  text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 disabled:bg-gainsboro',
  {
    variants: {
      variant: {
        'primary': 'bg-primary text-gunmetal hover:bg-primary/90',
        'secondary': 'bg-stormcloud text-primary-foreground disabled:text-gunmetal border-white border-1 font-normal hover:bg-stormcloud-600',
        'destructive': 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        'outline': 'border border-input bg-background border-white text-primary-foreground',
        'outline-secondary': 'border border-input bg-background border-tangerine text-gunmetal disabled:opacity-20',
        'icon-card': 'flex justify-start gap-2 bg-white border-l-[3px] border-tangerine text-xs transition duration-200 ease-in-out hover:text-tangerine',
        'ghost': 'hover:bg-accent hover:text-accent-foreground',
        'link': 'text-primary underline-offset-4 hover:underline',
        'icon': 'text-gunmetal bg-anti-flash-white',
        'round': 'bg-white rounded-full',
        'plain': ''
      },
      size: {
        'default': 'h-10 px-6 py-3 hover:rounded-tr-3xl',
        'xs': 'h-7 rounded px-2',
        'sm': 'h-9 rounded-md px-3',
        'lg': 'h-11 rounded-md px-9 py-4',
        'lg-not-rounded': 'h-11 px-9 py-4 hover:rounded-tr-3xl',
        'icon-card': 'min-h-11 px-4 py-4 hover:rounded-tr-3xl',
        'icon': 'h-10 w-10 '
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default'
    }
  }
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
